import { formatCurrency } from '~libs/dataUtils';
import { Column, Row } from '~components/table-view';

import PaymentBatchRowAction from '~direct-debits/components/payment-batches/PaymentBatchRowAction';
import PaymentStatusBadge from '~direct-debits/components/payment-batches/PaymentStatusBadge';
import { formatBatchDate } from '~direct-debits/lib/formatBatchDate';
import { PaymentBatch } from '~direct-debits/models';

export interface BatchListCallbacks {
  onSelectBatch?: (batchId: string) => void;
}

export const columnsFactory = (callbacks: BatchListCallbacks = {}): Column[] => [
  {
    // Both sort key and rendered value use the user-facing `DDB-NNNNNN`
    // reference — the UUID is never shown, and sorting on the hidden id would
    // produce visually-random results.
    id: 'reference',
    header: 'Batch ID',
    type: 'text',
    deriveValue: (row) => (row.reference as string) || '—',
  },
  {
    id: 'status',
    header: 'Status',
    type: 'custom',
    component: PaymentStatusBadge,
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'client_count',
    header: 'Clients',
    type: 'text',
    deriveValue: (row) => String(row.client_count ?? 0),
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'total_amount',
    header: 'Total Amount',
    type: 'text',
    deriveValue: (row) => formatCurrency(row.total_amount as string),
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
  {
    id: 'created_at',
    header: 'Created',
    type: 'text',
    deriveValue: (row) => formatBatchDate(row.created_at as string),
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: PaymentBatchRowAction,
    componentProps: callbacks,
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
];

export type PaymentBatchRow = Row & PaymentBatch;
